<div class="page-header" id="target">
    <h6 class="page-titles" style="cursor:context-menu;">
        <span class="page-title-icons bg-gradient-primary text-white mr-2">
            <i class="mdi mdi-calculator menu-icon"></i>
        </span> ประมาณการดอกเบี้ยเงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่
    </h6>
    <nav aria-label="breadcrumb">
        <button type="button" class="btn btn-gradient-danger" data-toggle="modal" data-target="#add_report"
            style="cursor: pointer;">
            อัตราดอกเบี้ย ณ ปัจจุบัน </button>

        <div class="modal fade" id="add_report" tabindex="-1" role="dialog" aria-labelledby="add_report"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" style="background-color: white;cursor:context-menu;">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel-2">อัตราดอกเบี้ย ณ ปัจจุบัน
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <h4>อัตราดอกเบี้ย MLR ตามประกาศธนาคารกรุงไทย</h4>
                            <table class="table table-bordered" style="border-top: 1px solid #ebedf2;">
                                <thead>
                                    <tr style="text-align: center;">
                                        <th> อัตราดอกเบี้ย </th>
                                        <th> ประกาศ ณ วันที่ </th>
                                        <th> มีผลบังคับใช้ ณ วันที่ </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style="text-align: center;">
                                        <td> {{data_con?.interest | number:'1.3-3'}} </td>
                                        <td> {{data_con?.date_declare_th}} </td>
                                        <td> {{data_con?.date_used_th}}</td>
                                    </tr>
                                </tbody>
                            </table><br>
                            <table class="table table-striped">
                                <thead>
                                    <tr class="text-center">
                                        <th class="table-30"> ผู้ดำเนินโครงการ </th>
                                        <th class="table-30"> ส่วนต่างอัตราดอกเบี้ย </th>
                                        <th class="table-20"> อัตราดอกเบี้ย </th>
                                        <th class="table-10"> </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="table-30"> สมาคม (โครงการในพื้นที่เป้าหมาย) </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.500 </td>
                                        <td class="table-20"> {{data_con?.interest - 3.5 | number:'1.3-3'}}
                                        </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                    <tr>
                                        <td class="table-30"> สมาคม (โครงการนอกพื้นที่เป้าหมาย) </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 2.000 </td>
                                        <td class="table-20"> {{data_con?.interest - 2 | number:'1.3-3'}} </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                    <tr>
                                        <td class="table-30"> องค์กรปกครองส่วนท้องถิ่น </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.000 </td>
                                        <td class="table-20"> {{data_con?.interest - 3 | number:'1.3-3'}} </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                    <tr>
                                        <td class="table-30"> การเคหะแห่งชาติ </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.000 </td>
                                        <td class="table-20"> {{data_con?.interest - 3 | number:'1.3-3'}} </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                    <tr>
                                        <td class="table-30"> กรมโยธาธิการและผังเมือง </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.000 </td>
                                        <td class="table-20"> {{data_con?.interest - 3 | number:'1.3-3'}} </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                    <tr>
                                        <td class="table-30">
                                            หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 2.000 </td>
                                        <td class="table-20"> {{data_con?.interest - 2 | number:'1.3-3'}} </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                    <tr>
                                        <td class="table-30"> หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง </td>
                                        <td class="table-30 text-center"> น้อยกว่าร้อยละ 2.000 </td>
                                        <td class="table-20"> {{data_con?.interest - 2 | number:'1.3-3'}} </td>
                                        <td class="table-10"> ร้อยละต่อปี </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</div>

<div class="row">
    <div class="col-12 grid-margin">
        <div *ngIf="isDisplayCalculate">
            <div class="card" style="border-radius: 15px;">
                <div class="card-body">
                    <div style="margin-left: auto; margin-right: auto;">
                        <form class="forms-sample" style="margin-left: auto; margin-right: auto;" id="form"
                            #form="ngForm" novalidate>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label
                                            class="col-md-5 col-sm-12 col-form-label">โครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่<span
                                                *ngIf="!form.value.area" class="rq"> *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <input type="text" class="form-control" name="area"
                                                [(ngModel)]="data_cal.area" ngControl="area" autocomplete="off"
                                                required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label class="col-md-5 col-sm-12 col-form-label">ผู้ดำเนินโครงการ<span
                                                *ngIf="!form.value.operator" class="rq"> *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <select class="form-control form-control-lg" name="operator"
                                                [(ngModel)]="data_cal.operator"
                                                (change)="select_operator($event)" ngControl="operator"
                                                autocomplete="off" required>
                                                <option *ngFor="let op of operators!">{{op}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label class="col-md-5 col-sm-12 col-form-label">โดย<span
                                                *ngIf="!form.value.creator" class="rq"> *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <input type="text" class="form-control" name="creator"
                                                [(ngModel)]="data_cal.creator" ngControl="creator"
                                                autocomplete="off" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label class="col-md-5 col-sm-12 col-form-label">อัตราดอกเบี้ยเงินกู้ยืม
                                            (ร้อยละ)</label>
                                        <div class="col-md-7 col-sm-12">
                                            <input class="form-control" name="interest"
                                                [(ngModel)]="data_cal.interest" ngControl="interest" disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label class="col-md-5 col-sm-12 col-form-label">วงเงินกู้ยืม
                                            (บาท)<span *ngIf="!form.value.budget" class="rq"> *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <input type="text" min="0" class="form-control" name="budget"
                                                [(ngModel)]="data_cal.budget" ngControl="budget"
                                                autocomplete="off" required mask="separator" thousandSeparator="," [allowNegativeNumbers]="true">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label class="col-md-5 col-sm-12 col-form-label">วันที่กู้ยืม<span
                                                *ngIf="!form.value.loan_date" class="rq"> *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <input type="date" class="form-control" name="loan_date"
                                                [(ngModel)]="data_cal.loan_date" ngControl="loan_date"
                                                autocomplete="off" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label class="col-md-5 col-sm-12 col-form-label">ระยะเวลาการกู้ยืม
                                            (ปี)<span *ngIf="!form.value.loan_length" class="rq"> *</span>
                                        </label>
                                        <div class="col-md-7 col-sm-12">
                                            <input type="number"  min="1" class="form-control" name="loan_length"
                                                [(ngModel)]="data_cal.loan_length" ngControl="loan_length"
                                                autocomplete="off" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5>เงื่อนไขการชำระเงินคืน</h5><br>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label
                                            class="col-md-5 col-sm-12 col-form-label">ขอปลอดการชำระเงินต้นเป็นเวลา
                                            (ปี)<span *ngIf="!form.value.principle_gp" class="rq">
                                                *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <select class="form-control form-control-lg" name="principle_gp"
                                                [(ngModel)]="data_cal.principle_gp" ngControl="principle_gp"
                                                autocomplete="off" required>
                                                <option *ngFor="let y of years!">{{y}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group row">
                                        <label
                                            class="col-md-5 col-sm-12 col-form-label">ขอปลอดการชำระดอกเบี้ยเป็นเวลา
                                            (ปี)<span *ngIf="!form.value.interest_gp" class="rq">
                                                *</span></label>
                                        <div class="col-md-7 col-sm-12">
                                            <select class="form-control form-control-lg" name="interest_gp"
                                                [(ngModel)]="data_cal.interest_gp" ngControl="operator"
                                                autocomplete="off" required>
                                                <option *ngFor="let y of years!">{{y}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="text-align: center;">
                                <i class="mdi mdi-refresh reset-b"
                                    (click)="reset(form)"><span>รีเซ็ตค่า</span></i><br>
                                <button class="btn btn-gradient-primary" type="reset"
                                    (click)="calculater(form)" [disabled]="!form.valid">คำนวณ</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="isDisplayResule">
            <div class="card" style="border-radius: 15px; margin-top: 20px; overflow: auto;
        scroll-behavior: smooth;">
                <div class="card-body" id="print-section">
                    <div style="margin-left: auto; margin-right: auto;">
                        <div class="col-12" style="width: 100%;">
                            <p class="d-block h3 mb-0 fw-b"
                                style="text-align: center; font-size: 16pt; font-weight: 600;">ประมาณการดอกเบี้ยเงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่</p>
                            <p class="d-block mb-0 fw-b"
                                style="text-align: center; font-size: 14pt; font-weight: 600;">ตารางการชำระเงินต้นพร้อมดอกเบี้ย</p>
                            <br>
                            <div class="col-md-12 col-sm-12" style="width: 100%;">
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">เงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a>{{data_cal.area}}</a>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">ผู้ดำเนินโครงการ</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a>{{data_cal.operator}}</a>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">โดย</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a>{{data_cal.creator}}</a>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">จำนวนเงินกู้</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12 row" style="width: 50%; display: -webkit-box;
                                    display: -ms-flexbox;
                                    display: flex;
                                    -ms-flex-wrap: wrap;
                                    flex-wrap: wrap;">
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_budget | number:'1.2-2'}}</a>
                                        </div>
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a class="fw-b">บาท</a></div>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">อัตราดอกเบี้ยเงินกู้ยืม</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12 row" style="width: 50%;display: -webkit-box;
                                    display: -ms-flexbox;
                                    display: flex;
                                    -ms-flex-wrap: wrap;
                                    flex-wrap: wrap;">
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.interest |
                                                number:'1.3-3'}}</a></div>
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a class="fw-b">ร้อยละต่อปี</a></div>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">วันที่กู้ยืม</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12" style="width: 50%;"><a>{{data_date}}</a></div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">ระยะเวลากู้</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12 row" style="width: 50%; display: -webkit-box;
                                    display: -ms-flexbox;
                                    display: flex;
                                    -ms-flex-wrap: wrap;
                                    flex-wrap: wrap;">
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.loan_length}}</a></div>
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a class="fw-b">ปี</a></div>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a class="fw-b" style="font-weight: 600;">เงื่อนไขการชำระเงินคืน</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a> </a>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a>ขอปลอดการชำระเงินต้นเป็นเวลา</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12 row" style="width: 50%; display: -webkit-box;
                                    display: -ms-flexbox;
                                    display: flex;
                                    -ms-flex-wrap: wrap;
                                    flex-wrap: wrap;">
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.principle_gp}}</a></div>
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>ปี</a></div>
                                    </div>
                                </div>
                                <div class="row" style="display: -webkit-box;
                                display: -ms-flexbox;
                                display: flex;
                                -ms-flex-wrap: wrap;
                                flex-wrap: wrap;
                                margin-top: 10px;">
                                    <div class="col-md-6 col-sm-12" style="width: 50%;">
                                        <a>ขอปลอดการชำระดอกเบี้ยเป็นเวลา</a>
                                    </div>
                                    <div class="col-md-6 col-sm-12 row" style="width: 50%;display: -webkit-box;
                                    display: -ms-flexbox;
                                    display: flex;
                                    -ms-flex-wrap: wrap;
                                    flex-wrap: wrap;">
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.interest_gp}}</a></div>
                                        <div class="col-md-6 col-sm-3" style="width: 50%;"><a>ปี</a></div>
                                    </div>
                                </div>
                            </div><br>
                            <div class="table-responsive">
                                <table class="table table-bordered table-hover"
                                style="border: 1px solid #ebedf2;border-collapse: collapse; width: 100%;">
                                    <thead>
                                        <tr style="text-align: center;">
                                            <th class="tab-12" style="border: 1px solid #ebedf2; width: 12%; padding: 10px; font-weight: 400; font-size: 12pt;"> ปีที่ </th>
                                            <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> วันครบกำหนดชำระเงิน </th>
                                            <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> ดอกเบี้ย </th>
                                            <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> เงินต้น </th>
                                            <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> เงินต้นพร้อมดอกเบี้ย </th>
                                        </tr>
                                    </thead>
                                    <tbody style="text-align: center;">
                                        <tr *ngFor="let cal of calculates!; let i = index">
                                            <td class="tab-12" style="border: 1px solid #ebedf2; width: 12%; padding: 10px;"> {{i+1}} </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.date}} </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.interest | number:'1.2-2'}} </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.principle | number:'1.2-2'}} </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.sum | number:'1.2-2'}} </td>
                                        </tr>
                                        <tr>
                                            <td class="tab-12" style="border: 1px solid #ebedf2; width: 12%; padding: 10px;"> </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> รวม </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{sum_interest! | number:'1.2-2'}} </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{sum_principle! | number:'1.2-2'}} </td>
                                            <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{sum_sum! | number:'1.2-2'}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <a style="font-size: 10pt; float: right; margin-top: 10px;">คำนวณ ณ วันที่ {{date_today!}}</a>
                        </div>
                    </div>
                </div>
                <div style="text-align: center; margin-bottom: 30px;">
                    <button class="btn btn-gradient-danger" (click)="close()">ปิด</button>
                    <button class="btn btn-gradient-primary" style="margin-left: 20px;" printTitle="ประมาณการดอกเบี้ยเงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่" [useExistingCss]="false" printSectionId="print-section" ngxPrint><i class="mdi mdi-file-pdf btn-icon-prepend"></i>พิมพ์รายงาน</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <app-header-landing id="target"></app-header-landing>
<div style="width: 100%;">
    <div class="content-wrapper">
        <div class="page-header">
            <h3 class="page-titles" style="cursor:context-menu;">
                <span class="page-title-icons bg-gradient-primary text-white mr-2">
                    <i class="mdi mdi-calculator menu-icon"></i>
                </span> ประมาณการดอกเบี้ยเงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่
            </h3>
            <nav aria-label="breadcrumb">
                <button type="button" class="btn btn-gradient-danger" data-toggle="modal" data-target="#add_report"
                    style="cursor: pointer;">
                    อัตราดอกเบี้ย ณ ปัจจุบัน </button>

                <div class="modal fade" id="add_report" tabindex="-1" role="dialog" aria-labelledby="add_report"
                    aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content" style="background-color: white;cursor:context-menu;">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel-2">อัตราดอกเบี้ย ณ ปัจจุบัน
                                </h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="table-responsive">
                                    <h4>อัตราดอกเบี้ย MLR ตามประกาศธนาคารกรุงไทย</h4>
                                    <table class="table table-bordered" style="border-top: 1px solid #ebedf2;">
                                        <thead>
                                            <tr style="text-align: center;">
                                                <th> อัตราดอกเบี้ย </th>
                                                <th> ประกาศ ณ วันที่ </th>
                                                <th> มีผลบังคับใช้ ณ วันที่ </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="text-align: center;">
                                                <td> {{data_con?.interest | number:'1.3-3'}} </td>
                                                <td> {{data_con?.date_declare_th}} </td>
                                                <td> {{data_con?.date_used_th}}</td>
                                            </tr>
                                        </tbody>
                                    </table><br>
                                    <table class="table table-striped">
                                        <thead>
                                            <tr class="text-center">
                                                <th class="table-30"> ผู้ดำเนินโครงการ </th>
                                                <th class="table-30"> ส่วนต่างอัตราดอกเบี้ย </th>
                                                <th class="table-20"> อัตราดอกเบี้ย </th>
                                                <th class="table-10"> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="table-30"> สมาคม (โครงการในพื้นที่เป้าหมาย) </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.500 </td>
                                                <td class="table-20"> {{data_con?.interest - 3.5 | number:'1.3-3'}}
                                                </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                            <tr>
                                                <td class="table-30"> สมาคม (โครงการนอกพื้นที่เป้าหมาย) </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 2.000 </td>
                                                <td class="table-20"> {{data_con?.interest - 2 | number:'1.3-3'}} </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                            <tr>
                                                <td class="table-30"> องค์กรปกครองส่วนท้องถิ่น </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.000 </td>
                                                <td class="table-20"> {{data_con?.interest - 3 | number:'1.3-3'}} </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                            <tr>
                                                <td class="table-30"> การเคหะแห่งชาติ </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.000 </td>
                                                <td class="table-20"> {{data_con?.interest - 3 | number:'1.3-3'}} </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                            <tr>
                                                <td class="table-30"> กรมโยธาธิการและผังเมือง </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 3.000 </td>
                                                <td class="table-20"> {{data_con?.interest - 3 | number:'1.3-3'}} </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                            <tr>
                                                <td class="table-30">
                                                    หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 2.000 </td>
                                                <td class="table-20"> {{data_con?.interest - 2 | number:'1.3-3'}} </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                            <tr>
                                                <td class="table-30"> หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง </td>
                                                <td class="table-30 text-center"> น้อยกว่าร้อยละ 2.000 </td>
                                                <td class="table-20"> {{data_con?.interest - 2 | number:'1.3-3'}} </td>
                                                <td class="table-10"> ร้อยละต่อปี </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>

        <div class="row">
            <div class="col-12 grid-margin">
                <div *ngIf="isDisplayCalculate">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <div style="margin-left: auto; margin-right: auto;">
                                <form class="forms-sample" style="margin-left: auto; margin-right: auto;" id="form"
                                    #form="ngForm" novalidate>
                                    <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label
                                                    class="col-md-5 col-sm-12 col-form-label">โครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่<span
                                                        *ngIf="!form.value.area" class="rq"> *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <input type="text" class="form-control" name="area"
                                                        [(ngModel)]="data_cal.area" ngControl="area" autocomplete="off"
                                                        required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label class="col-md-5 col-sm-12 col-form-label">ผู้ดำเนินโครงการ<span
                                                        *ngIf="!form.value.operator" class="rq"> *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <select class="form-control form-control-lg" name="operator"
                                                        [(ngModel)]="data_cal.operator"
                                                        (change)="select_operator($event)" ngControl="operator"
                                                        autocomplete="off" required>
                                                        <option *ngFor="let op of operators!">{{op}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label class="col-md-5 col-sm-12 col-form-label">โดย<span
                                                        *ngIf="!form.value.creator" class="rq"> *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <input type="text" class="form-control" name="creator"
                                                        [(ngModel)]="data_cal.creator" ngControl="creator"
                                                        autocomplete="off" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label class="col-md-5 col-sm-12 col-form-label">อัตราดอกเบี้ยเงินกู้ยืม
                                                    (ร้อยละ)</label>
                                                <div class="col-md-7 col-sm-12">
                                                    <input class="form-control" name="interest"
                                                        [(ngModel)]="data_cal.interest" ngControl="interest" disabled>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label class="col-md-5 col-sm-12 col-form-label">วงเงินกู้ยืม
                                                    (บาท)<span *ngIf="!form.value.budget" class="rq"> *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <input type="text" min="0" class="form-control" name="budget"
                                                        [(ngModel)]="data_cal.budget" ngControl="budget"
                                                        autocomplete="off" required mask="separator" thousandSeparator="," [allowNegativeNumbers]="true">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label class="col-md-5 col-sm-12 col-form-label">วันที่กู้ยืม<span
                                                        *ngIf="!form.value.loan_date" class="rq"> *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <input type="date" class="form-control" name="loan_date"
                                                        [(ngModel)]="data_cal.loan_date" ngControl="loan_date"
                                                        autocomplete="off" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label class="col-md-5 col-sm-12 col-form-label">ระยะเวลาการกู้ยืม
                                                    (ปี)<span *ngIf="!form.value.loan_length" class="rq"> *</span>
                                                </label>
                                                <div class="col-md-7 col-sm-12">
                                                    <input type="number"  min="1" class="form-control" name="loan_length"
                                                        [(ngModel)]="data_cal.loan_length" ngControl="loan_length"
                                                        autocomplete="off" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h5>เงื่อนไขการชำระเงินคืน</h5><br>
                                    <div class="row">
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label
                                                    class="col-md-5 col-sm-12 col-form-label">ขอปลอดการชำระเงินต้นเป็นเวลา
                                                    (ปี)<span *ngIf="!form.value.principle_gp" class="rq">
                                                        *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <select class="form-control form-control-lg" name="principle_gp"
                                                        [(ngModel)]="data_cal.principle_gp" ngControl="principle_gp"
                                                        autocomplete="off" required>
                                                        <option *ngFor="let y of years!">{{y}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group row">
                                                <label
                                                    class="col-md-5 col-sm-12 col-form-label">ขอปลอดการชำระดอกเบี้ยเป็นเวลา
                                                    (ปี)<span *ngIf="!form.value.interest_gp" class="rq">
                                                        *</span></label>
                                                <div class="col-md-7 col-sm-12">
                                                    <select class="form-control form-control-lg" name="interest_gp"
                                                        [(ngModel)]="data_cal.interest_gp" ngControl="operator"
                                                        autocomplete="off" required>
                                                        <option *ngFor="let y of years!">{{y}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="text-align: center;">
                                        <i class="mdi mdi-refresh reset-b"
                                            (click)="reset(form)"><span>รีเซ็ตค่า</span></i><br>
                                        <button class="btn btn-gradient-primary" type="submit"
                                            (click)="calculater(form)" [disabled]="!form.valid">คำนวณ</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="isDisplayResule">
                    <div class="card" style="border-radius: 15px; margin-top: 20px; overflow: auto;
                scroll-behavior: smooth;">
                        <div class="card-body" id="print-section">
                            <div style="margin-left: auto; margin-right: auto;">
                                <div class="col-12" style="width: 100%;">
                                    <p class="d-block h3 mb-0 fw-b"
                                        style="text-align: center; font-size: 16pt; font-weight: 600;">ประมาณการดอกเบี้ยเงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่</p>
                                    <p class="d-block mb-0 fw-b"
                                        style="text-align: center; font-size: 14pt; font-weight: 600;">ตารางการชำระเงินต้นพร้อมดอกเบี้ย</p>
                                    <br>
                                    <div class="col-md-12 col-sm-12" style="width: 100%;">
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">เงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a>{{data_cal.area}}</a>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">ผู้ดำเนินโครงการ</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a>{{data_cal.operator}}</a>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">โดย</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a>{{data_cal.creator}}</a>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">จำนวนเงินกู้</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12 row" style="width: 50%; display: -webkit-box;
                                            display: -ms-flexbox;
                                            display: flex;
                                            -ms-flex-wrap: wrap;
                                            flex-wrap: wrap;">
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_budget | number:'1.2-2'}}</a>
                                                </div>
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a class="fw-b">บาท</a></div>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">อัตราดอกเบี้ยเงินกู้ยืม</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12 row" style="width: 50%;display: -webkit-box;
                                            display: -ms-flexbox;
                                            display: flex;
                                            -ms-flex-wrap: wrap;
                                            flex-wrap: wrap;">
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.interest |
                                                        number:'1.3-3'}}</a></div>
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a class="fw-b">ร้อยละต่อปี</a></div>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">วันที่กู้ยืม</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12" style="width: 50%;"><a>{{data_date}}</a></div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">ระยะเวลากู้</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12 row" style="width: 50%; display: -webkit-box;
                                            display: -ms-flexbox;
                                            display: flex;
                                            -ms-flex-wrap: wrap;
                                            flex-wrap: wrap;">
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.loan_length}}</a></div>
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a class="fw-b">ปี</a></div>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a class="fw-b" style="font-weight: 600;">เงื่อนไขการชำระเงินคืน</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a> </a>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a>ขอปลอดการชำระเงินต้นเป็นเวลา</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12 row" style="width: 50%; display: -webkit-box;
                                            display: -ms-flexbox;
                                            display: flex;
                                            -ms-flex-wrap: wrap;
                                            flex-wrap: wrap;">
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.principle_gp}}</a></div>
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>ปี</a></div>
                                            </div>
                                        </div>
                                        <div class="row" style="display: -webkit-box;
                                        display: -ms-flexbox;
                                        display: flex;
                                        -ms-flex-wrap: wrap;
                                        flex-wrap: wrap;
                                        margin-top: 10px;">
                                            <div class="col-md-6 col-sm-12" style="width: 50%;">
                                                <a>ขอปลอดการชำระดอกเบี้ยเป็นเวลา</a>
                                            </div>
                                            <div class="col-md-6 col-sm-12 row" style="width: 50%;display: -webkit-box;
                                            display: -ms-flexbox;
                                            display: flex;
                                            -ms-flex-wrap: wrap;
                                            flex-wrap: wrap;">
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>{{data_cal.interest_gp}}</a></div>
                                                <div class="col-md-6 col-sm-3" style="width: 50%;"><a>ปี</a></div>
                                            </div>
                                        </div>
                                    </div><br>
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-hover"
                                        style="border: 1px solid #ebedf2;border-collapse: collapse; width: 100%;">
                                            <thead>
                                                <tr style="text-align: center;">
                                                    <th class="tab-12" style="border: 1px solid #ebedf2; width: 12%; padding: 10px; font-weight: 400; font-size: 12pt;"> ปีที่ </th>
                                                    <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> วันครบกำหนดชำระเงิน </th>
                                                    <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> ดอกเบี้ย </th>
                                                    <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> เงินต้น </th>
                                                    <th class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px; font-weight: 400; font-size: 12pt;"> เงินต้นพร้อมดอกเบี้ย </th>
                                                </tr>
                                            </thead>
                                            <tbody style="text-align: center;">
                                                <tr *ngFor="let cal of calculates!; let i = index">
                                                    <td class="tab-12" style="border: 1px solid #ebedf2; width: 12%; padding: 10px;"> {{i+1}} </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.date}} </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.interest | number:'1.2-2'}} </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.principle | number:'1.2-2'}} </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{cal!.sum | number:'1.2-2'}} </td>
                                                </tr>
                                                <tr>
                                                    <td class="tab-12" style="border: 1px solid #ebedf2; width: 12%; padding: 10px;"> </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> รวม </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{sum_interest! | number:'1.2-2'}} </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{sum_principle! | number:'1.2-2'}} </td>
                                                    <td class="tab-22" style="border: 1px solid #ebedf2; width: 22%; padding: 10px;"> {{sum_sum! | number:'1.2-2'}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <a style="font-size: 10pt; float: right; margin-top: 10px;">คำนวณ ณ วันที่ {{date_today!}}</a>
                                </div>
                            </div>
                        </div>
                        <div style="text-align: center; margin-bottom: 30px;">
                            <button class="btn btn-gradient-danger" (click)="close()">ปิด</button>
                            <button class="btn btn-gradient-primary" style="margin-left: 20px;" printTitle="ประมาณการดอกเบี้ยเงินให้กู้ยืมโครงการจัดรูปที่ดินเพื่อพัฒนาพื้นที่" [useExistingCss]="false" printSectionId="print-section" ngxPrint><i class="mdi mdi-file-pdf btn-icon-prepend"></i>พิมพ์รายงาน</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer class="footer" style="padding-top: 10px; padding-bottom: 10px;">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
                <span class="text-muted text-center text-sm-left d-block d-sm-inline-block" style="margin-top: auto; margin-bottom: 0px;">Copyright © 2023 <a
                        href="https://www.mapedia.co.th/" target="_blank">MAPEDIA . co . th</a>. All rights
                    reserved.</span>
                <div class="text-right">
                    <div class="text-right" style="margin-right: 3px;">จำนวนผู้เข้าชมเว็บไซต์</div>
                    <div class="text-right">
                        <span class="count-visitor" *ngFor="let i of visitor">{{i}}</span>
                    </div>
                </div>
            </div>
        </footer> -->